import React, {Component} from 'react';
import ReactFC from 'react-fusioncharts';
/* Fusionchar react and charts*/
import FusionCharts from 'fusioncharts/core';
import FusionMaps from 'fusioncharts/maps';
import Usa from 'fusioncharts/maps/es/fusioncharts.usa';
/* Utils */
import {chartConfigGenerator, usaMapGenerator, usaMapSecondGenerator, usaMapThirdGenerator, CustomerTabLoader} from '../util';

FusionCharts.addDep(FusionMaps);
FusionCharts.addDep(Usa);

export default class ChartContainer extends Component {
    constructor (props) {
      super(props);
      this.state = {
        activeTab: 'map-link-1'
      }
    }

    /**
     * 
     * @param {ReactFCComponent} component 
     * @param {Array} data 
     * @returns SubComponent Containing ReactFC Component as a child.
     */
    mapGenerator (component, data) {
      return (
      <div className="row m-auto jutify-content-center chart-container">
        <div className="col-12 chart-wrapper" id="chart-wrapper1">
          <div className="kpi-header">
              <div className="map-link" id="map-link-1"><a className={(this.state.activeTab === 'map-link-1') ? 'activeText': ''} onClick={(e)=> {this.handleClick(e)}}>Shipment Count</a></div>
              <div className="map-link" id="map-link-2"><a className={this.state.activeTab === 'map-link-2' ? 'activeText': ''} onClick={(e)=> {this.handleClick(e)}}>Bill Amount</a></div>
              <div className="map-link" id="map-link-3"><a className={this.state.activeTab === 'map-link-3' ? 'activeText': ''} onClick={(e)=> {this.handleClick(e)}}>Average Miles</a></div>
          </div>
          <div className="chart"  id="chart-container1">{(data.length) ? component : <CustomerTabLoader/>}</div>
        </div>
      </div>
      )
    }
    
    render () {
      let {data, timeSelectorValue} = this.props,
      {activeTab} = this.state;

      if (activeTab === 'map-link-1') {
      return (
        <div>
          {this.mapGenerator(<ReactFC {...chartConfigGenerator({type: 'usa', dataSource: usaMapGenerator, data: data, timeSelectorValue: timeSelectorValue })}/>, data)}
        </div>
        );
      } else if (activeTab === 'map-link-2') {
        return (
          <div>
            {this.mapGenerator(<ReactFC {...chartConfigGenerator({type: 'usa', 'dataEmptyMessage':'', dataSource: usaMapSecondGenerator, data: data, timeSelectorValue: timeSelectorValue })} />, data)}
          </div>
        );
      } else if (activeTab === 'map-link-3') {
        return (
          <div>
            {this.mapGenerator(<ReactFC {...chartConfigGenerator({type: 'usa', 'dataEmptyMessage':'', dataSource: usaMapThirdGenerator, data: data, timeSelectorValue: timeSelectorValue })} />, data)}
          </div>
        );
      }
    }

/**
 * Function to set the id of clicked map
 * This will set the state of component accordingly.
 */
    handleClick = (e) => {
      this.setState({activeTab: e.target.parentNode.id});
    }
  }


// WEBPACK FOOTER //
// ./src/components/RegionalPerformanceTab.js